import React from "react"
import { Info } from "lucide-react"

export const FaxNumberToolTip = ({ size = 16, className = "" }) => {
  return (
    <span className={`tooltip-container ${className}`}>
      <Info
        size={size}
        color="grey"
        style={{
          verticalAlign: "middle",
          marginLeft: "5px",
          cursor: "pointer",
        }}
      />

      <span className="tooltip-text">
        For U.S. numbers, enter 1 for 11-digit numbers, or if entering a
        10-digit number, it should begin with > 1
        <br />
        <br />
        For international numbers, please begin with a +
        <br />
        <br />
        <span>Examples:</span>
        <br />
        ----- [USA] -----
        <br />
        12234567891
        <br />
        1-223-456-7891
        <br />
        223-456-7891
        <br />
        +1-223-456-7891
        <br />
        <br />
        ----- [International] -----
        <br />
        +8454353453
        <br />
        +8-454-353-4532
        <br />
      </span>
    </span>
  )
}
